import * as dayjs from 'dayjs';
import { Account } from './account.model';

export interface ICalculo {

  id?: number;

  nome?: string | null;

  email?: string | null;

  cpfCnpj?: string | null;

  telefone?: string | null;

  calculo?: string | null;

  observacao?: string | null;

  dataAtualizacao?: dayjs.Dayjs | null;

  timestamp?: dayjs.Dayjs | null;

  user?: Account | null;

}

export class Calculo implements ICalculo {

  constructor(public id?: number,

    public nome?: string | null,

    public email?: string | null,

    public cpfCnpj?: string | null,

    public telefone?: string | null,

    // public calculo?: string | null,

    // public observacao?: string | null,

    // public dataAtualizacao?: dayjs.Dayjs | null,

    // public timestamp?: dayjs.Dayjs | null,

    public user?: Account | null) {}

}

export function getCalculoIdentifier(calculo: ICalculo): number | undefined {

  return calculo.id;

}
